(() => {
    // Clear form if it has been sumbitted
    $(document).ready(() => {
        const $container = $('.newslettersignupblock');
        const $form = $container.length ? $container.find('.EPiServerForms.ValidationSuccess') : null;
        
        if ($form) {
            $form.find('[name="__FormCurrentStepIndex"]').val(0);
            $form.find('.Form__Element.FormTextbox').each((index, el) => {
                $(el).find('input').val('');
            })
        }
  })
})();